import "./confirm.scss";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import ICON_DELETE from "../../assets/images/trash.svg";
import Button from '@mui/material/Button';

interface ConfirmProps {
    show: boolean;
    type: 'delete' | 'hide';
    onClose: (value: boolean) => void;
}

const ConfirmModal: React.FC<ConfirmProps> = ({ show, type, onClose }) => {

    const content = {
        delete: { title: 'ยืนยันการลบ', description: 'คุณแน่ใจหรือไม่ว่าต้องการลบ?' },
        hide: { title: 'คุณต้องการที่จะซ่อนรายการนี้', description: 'รายการนี้จะถูกย้ายไปยังรายการที่ถูกซ่อน และคุณสามารถนำกลับมาใช้งานอีกครั้งได้' },
    }

    const handleClose = () => {
        onClose(false);
    }

    const handleConfirm = () => {
        onClose(true);
    }

    return (
        <Modal show={show} onHide={handleClose} centered className="confirm-modal">
            <Modal.Body className='confirm-modal-wrapper'>
                <FontAwesomeIcon icon={faClose} className="modal-icon-close" onClick={handleClose}></FontAwesomeIcon>

                <div className="mb-2">
                    {
                        (type === 'delete') && <img src={ICON_DELETE} width={40} />
                    }
                </div>

                <p className="confirm-modal-title">
                    {
                        content[type].title
                    }
                </p>

                <p className="confirm-modal-description">
                    {
                        content[type].description
                    }
                </p>

                <div className="confirm-modal-action">
                    <Button
                        variant="outlined"
                        className="confirm-modal-button"
                        onClick={handleClose}
                    >
                        ยกเลิก
                    </Button>

                    <Button
                        variant="contained"
                        className="confirm-modal-button"
                        onClick={handleConfirm}
                    >
                        ยืนยัน
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default ConfirmModal;